import { HaftpflichtSchadenSpritzschaden } from '@gsm/entities';
import { DynamicFormControlLayout, serializable } from '@ng-dynamic-forms/core';
import { BaseHaftpflichtSchadenModel, BaseHaftpflichtSchadenModelConfig, HaftpflichtAdditional } from '../shared-models/haftpflichtschaden.model';

export const TYPE_HAFTPFLICHT_SACHSCHADEN_WALDARBEITEN = 'HAFTPFLICHT-SACHSCHADEN-WALDARBEITEN';

export interface HaftpflichtWaldarbeitenAdditional extends HaftpflichtAdditional {
  spritzschaden?: boolean;
}

export interface HaftpflichtSachschadenWaldarbeitenModelConfig extends BaseHaftpflichtSchadenModelConfig<HaftpflichtSchadenSpritzschaden> {
  additional: HaftpflichtWaldarbeitenAdditional;
}

export class HaftpflichtSachschadenWaldarbeitenModel extends BaseHaftpflichtSchadenModel<HaftpflichtSchadenSpritzschaden> {
  @serializable() readonly type: string = TYPE_HAFTPFLICHT_SACHSCHADEN_WALDARBEITEN;
  @serializable() additional: HaftpflichtWaldarbeitenAdditional;

  constructor(config: HaftpflichtSachschadenWaldarbeitenModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
    // additional is set from super()
  }
}
